import { Component, OnInit, Input, SimpleChanges, forwardRef, ViewChild } from '@angular/core';
import { 
    IonContent, IonGrid, IonRow, IonCol, IonSpinner
} from '@ionic/angular/standalone';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvTabsComponent, MarvTabComponent, MarvTab } from '@marv/components';
import { StoreDashboard } from '@app/models';
import { StoreService, OperationService } from '@app/services';
import { 
    RetailerLogoComponent, RetailerLogo, StoreDetailsInfosComponent, StoreDetailsInfos, 
    StoreDetailsAdditionalDataComponent, StoreDetailsMissionsComponent, StoreDetailsPhotosComponent 
} from '@app/components';

export type StoreDetailsTab = 'infos'|'additional-data'|'missions'|'photos';

@Component({
    selector: 'app-store-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss'],
    imports: [
        IonContent, IonGrid, IonRow, IonCol, IonSpinner, TranslatePipe, forwardRef(() => MarvTabsComponent), forwardRef(() => MarvTabComponent),
        forwardRef(() => RetailerLogoComponent), forwardRef(() => StoreDetailsInfosComponent), forwardRef(() => StoreDetailsAdditionalDataComponent), 
        forwardRef(() => StoreDetailsMissionsComponent), forwardRef(() => StoreDetailsPhotosComponent)
    ]
})
export class StoreDetailsComponent  implements OnInit {

    @Input({alias : 'storeId', required : true}) storeId: number;
    @Input({alias : 'showDetailsMission', required : false}) showDetailsMission: boolean = true;
    @Input({alias : 'tabSelected', required : false}) tabSelected: StoreDetailsTab = 'infos';
    
    @ViewChild(MarvTabsComponent) marvTabs: MarvTabsComponent
    
    tabsStore: Array<MarvTab> = [
        {id: 'infos', label: this.translateService.instant('INFORMATIONS'), defaultSelected: true},  
        // A MODIFIER - Ajouter dans l'API : Ajout des questionnaires de prise de commande + affichage du dernier questionnaire saisi (par OP)      
        {id: 'additional-data', label: this.translateService.instant('ADDITIONAL_DATA'), hide: true},
        {id: 'missions', label: this.translateService.instant('MISSIONS'), countItems: 0},
        {id: 'photos', label: this.translateService.instant('PICTURES')}
    ];
       
    isFetching: boolean = false;
    StoreDetailsInfos = StoreDetailsInfos;
    storeDashboard: StoreDashboard|null = null;    
    storeDetailsInfos: StoreDetailsInfos|null = null;    
    retailerLogo: RetailerLogo|null = null; 
    
    constructor(
        private translateService: TranslateService,
        private storeService: StoreService
    ) { }

    ngOnInit() {
        // A MODIFIER - Ajouter de la saisie des vitrines en dur
        let opCocaVitrine = OperationService.Operations.find(o => o.id === 2028) || null;
        let tabAdditionalsDatas = this.tabsStore.find(t => t.id === 'additional-data');
        if(opCocaVitrine !== null && tabAdditionalsDatas){
            tabAdditionalsDatas.hide = false;
        }
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['storeId'] && changes['storeId'].currentValue){
            this.getStoreDetails();
        }
        
        if(changes['tabSelected'] && changes['tabSelected'].currentValue){            
            let tab = this.tabsStore.find(t => t.id === this.tabSelected);
            if(tab){
                this.marvTabs?.selectTab(tab);
            }
        }
    }

    async getStoreDetails(){
        this.retailerLogo = null;
        this.storeDashboard = null;
        this.storeDetailsInfos = null;
        this.isFetching = true;
        if(this.storeId){
            this.storeDashboard = await this.storeService.loadStoreDashboard(this.storeId);               
            if(this.storeDashboard){
                this.storeDetailsInfos = StoreDetailsInfos.FromStoreDashboard(this.storeDashboard);
                let nbMissions = 0;
                if(this.storeDashboard.operationActivityReports){
                    for(let r of this.storeDashboard?.operationActivityReports){
                        nbMissions += r.plannedActivitiesCount;
                    }
                }
                let tabMissions = this.tabsStore.find(t => t.id === 'missions');
                if(tabMissions){
                    tabMissions.countItems = nbMissions;
                }

                if(this.storeDashboard.store?.retailerName){
                    this.retailerLogo = new RetailerLogo(this.storeDashboard.store.retailerName);
                }   
            }
        }
        this.isFetching = false;        
    }
}
